module.exports = __webpack_public_path__ + "static/media/management.5a3b59cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/estrategas/tools/management.svg
// module id = 607
// module chunks = 0